import { render, staticRenderFns } from "./SensitiveWordManage.vue?vue&type=template&id=1307c5e0&"
import script from "./SensitiveWordManage.vue?vue&type=script&lang=js&"
export * from "./SensitiveWordManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports